import { createFileRoute } from '@tanstack/react-router';
import { GuestJoinPage } from '@/features/meetings/pages/guest-join-page';

/**
 * The guest page of a meeting: outside the organisation routes (a guest belongs to no
 * organisation), behind the sign-in of the authenticated layout. The invitation token waits in
 * this tab's session storage (see `/meetings/join/$token`).
 */
export const Route = createFileRoute('/_auth/meetings/guest')({
  component: GuestJoinPage,
});
